"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Ads API
 * The Spotify Ads API.
 *
 * The version of the OpenAPI document: 3.0.0
 * Contact: selfserve-infra-api@spotify.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.PacingToJSON = exports.PacingFromJSONTyped = exports.PacingFromJSON = exports.Pacing = void 0;
/**
 * Set a pacing option to deliver your ads throughout the schedule of your ad set with standard pacing("PACING_EVEN"), or accelerated pacing("PACING_ASAP") to deliver your ads as quickly as possible.
 * @export
 */
exports.Pacing = {
    Asap: 'PACING_ASAP',
    Even: 'PACING_EVEN',
    FrontLoaded: 'PACING_FRONT_LOADED'
};
function PacingFromJSON(json) {
    return PacingFromJSONTyped(json, false);
}
exports.PacingFromJSON = PacingFromJSON;
function PacingFromJSONTyped(json, ignoreDiscriminator) {
    return json;
}
exports.PacingFromJSONTyped = PacingFromJSONTyped;
function PacingToJSON(value) {
    return value;
}
exports.PacingToJSON = PacingToJSON;
